import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import bg4 from "../../assets/images/img/bg-4.webp";

export default function WhyUs({ hideBackgroundImage }) {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  return (
    <div className="section section__services">
      {!hideBackgroundImage && (
        <img
          className="container-bg image-background left slide-from-left"
          src={bg4}
          alt="container background"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "1180px",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top left",
            pointerEvents: "none",
            zIndex: -1,
          }}
        />
      )}
      <div className="container services ">
        <h5 className="drop-from-top">
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>Why Genvix Tech?</font>
          </font>
        </h5>
        <div className="title drop-from-top">
          <h2 style={{ marginBottom: "30px" }}>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                See the results for yourself. Let’s craft an online identity
                that reflects your vision.
              </font>
            </font>
          </h2>
        </div>
        <div className="circles flex">
          <div className="circles-element year slide-from-left">
            <div className="circle">
              <h2 className="white">
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {new Date().getFullYear() - 2019}<sup style={{ fontSize: "19px" }}>+</sup>
                  </font>
                </font>
              </h2>
            </div>
            <h6>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  years of trusted service
                </font>
              </font>
            </h6>
          </div>
          <div className="circles-element projects slide-from-bottom">
            <div className="circle">
              <h2 className="white">
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    20<sup style={{ fontSize: "19px" }}>+</sup>
                  </font>
                </font>
              </h2>
            </div>
            <h6>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  projects completed
                </font>
              </font>
            </h6>
          </div>
          {/* <div className="circles-element rank">
                <div className="circle">
                  <h2 className="white">
                    <font style={{ verticalAlign: "inherit" }}>
                      <font style={{ verticalAlign: "inherit" }}>5.0</font>
                    </font>
                  </h2>
                </div>
                <h6>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Customer rating
                    </font>
                  </font>
                </h6>
              </div> */}
          <div className="circles-element clients slide-from-right">
            <div className="circle">
              <h2 className="white">
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    50<sup style={{ fontSize: "19px" }}>+</sup>
                  </font>
                </font>
              </h2>
            </div>
            <h6>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>Happy clients</font>
              </font>
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
}
